module.exports = "#rememberDevice{display:inline-block}\n"